import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';


@Component({
  selector: 'app-show-proof-linked-docs',
  templateUrl: './show-proof-linked-docs.component.html',
  styleUrls: ['./show-proof-linked-docs.component.scss']
})
export class ShowProofLinkedDocsComponent extends DialogContentBase {

  constructor(public dialog: DialogRef) {
    super(dialog);
    }

  @Input() public proofDocumentId: number;
  proofDocumentReferenceType: ReferenceType = ReferenceType.ProofDocument;
  

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }
}



